// features/workstations/tabs/close.js
// ═══════════════════════════════════════════════════════════
// CLOSE TAB — consultative sales skill (Build / Rehearse / Live).
// A universal Shift tool. Build is deterministic (instant, free);
// Rehearse role-plays via Jarvis; Live grades a transcript.
// ═══════════════════════════════════════════════════════════

import { useState } from 'react';
import ScriptBuilder from '../close/script-builder';
import Rehearse from '../close/rehearse';
import LiveAssist from '../close/live-assist';

const MODES = [
  { id: 'build', label: 'Build', hint: 'generate the script' },
  { id: 'rehearse', label: 'Rehearse', hint: 'role-play the prospect' },
  { id: 'live', label: 'Live', hint: 'assist on the call' },
];

export default function CloseTab({ workstation, userId }) {
  const [mode, setMode] = useState('build');

  if (!workstation || !userId) {
    return (
      <div className="ws-tab-content">
        <div className="ws-placeholder">
          <div className="ws-placeholder-eyebrow">Loading</div>
          <div className="ws-placeholder-title">Close</div>
          <div className="ws-placeholder-body">Preparing the sales coach…</div>
        </div>
      </div>
    );
  }

  return (
    <div className="ws-tab-content">
      <div className="ws-sectioned-header">
        <div className="ws-sectioned-title-block">
          <div className="ws-sectioned-eyebrow">Skill</div>
          <div className="ws-sectioned-title">Close</div>
          <div className="ws-sectioned-subtitle">
            Consultative sales coach — diagnose before you prescribe. Build the script, rehearse it, run it live.
          </div>
        </div>
      </div>

      <div style={{ padding: '0 24px 80px', maxWidth: 760 }}>
        <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
          {MODES.map((m) => {
            const on = mode === m.id;
            return (
              <button key={m.id} onClick={() => setMode(m.id)}
                style={{
                  padding: '9px 16px', borderRadius: 8, cursor: 'pointer', color: on ? '#c8a96e' : '#9a9aa6',
                  background: on ? 'rgba(200,169,110,.12)' : 'var(--surface-3)',
                  border: `1px solid ${on ? '#c8a96e' : 'var(--border-3)'}`, fontWeight: on ? 600 : 400, fontSize: 13,
                }}>
                {m.label}
                <span style={{ display: 'block', fontSize: 10, color: '#6a6a76', marginTop: 2 }}>{m.hint}</span>
              </button>
            );
          })}
        </div>

        {mode === 'build' && <ScriptBuilder workstation={workstation} userId={userId} />}
        {mode === 'rehearse' && <Rehearse />}
        {mode === 'live' && <LiveAssist />}
      </div>
    </div>
  );
}
